import styles from "./authen.module.css";
import { Button } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

export const Unconfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  return (
    <div className={styles.activation_page}>
      <img
        style={{
          marginTop: "16px",
          marginRight: "16px",
          height: "32px",
          width: "32px",
          float: "right",
        }}
        src="/Images/logo.png"
        alt=""
      />
      <div className={styles.authen_wrapper}>
        <div className={styles.name}>Adot</div>
        <div className={styles.activation_text}>
          <span style={{ marginRight: "4px" }}>Email</span>
          <span style={{ fontWeight: 900 }}>{email}</span>&nbsp;của bạn chưa kích
        </div>
        <div className={styles.activation_text}>hoạt.</div>
        <div className={styles.activation_text}>
          Vui lòng kiểm tra email để đăng nhập tài khoản
        </div>
        <Button
          type="primary"
          className={styles.authen_button}
          onClick={() => navigate("/login")}
        >
          Tiếp tục
        </Button>
      </div>
    </div>
  );
};